import { render, staticRenderFns } from "./AddDegree.vue?vue&type=template&id=3a6b517e&"
import script from "./AddDegree.vue?vue&type=script&lang=js&"
export * from "./AddDegree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports